export default __webpack_public_path__ + "static/media/collectif_icon.8fa997ec.svg";